<div class="position-absolute sidebar-opener mt-2 ml-2" *ngIf="!sidebarShow && !isShowButton && restaurant">
  <button class="btn btn-icon p-2" [ngStyle]="{'background': menu.color,'color': menu.colorText,'border-color': menu.color}" type="button" (click)="setSideMenu()">
    <i class="fas fa-bars"></i>
  </button>
</div>

<div class="sidebar-slider animate__animated" [ngClass]="{'slideInLeft': sidebarShow}"
  [ngStyle]="{'background': getMenuColor(), 'background-image': 'url(' + getBackground() + ')' }">
  <div class="sidebar-close" (click)="setSideMenu()" [ngStyle]="{'color': getMenuColorText()}" *ngIf="isMobile">
    X
  </div>
  <div class="sidebar-content {{menu.fontHeader}}" [ngStyle]="{'color': getMenuColorText()}">
    <div class="row" *ngIf="menu.imageSideMenu">
      <div class="col">
        <img [src]="menu.imageSideMenu" alt="" class="sidebar-image">
      </div>
    </div>
    <h2 class="{{menu.fontSections? menu.fontSections: menu.fontHeader}}" [ngStyle]="{'color': getMenuColorText()}" *ngIf="!menu.imageSideMenu">{{restaurant.name | titlecase }}
    </h2>
    <div (click)="goHome()" class="sidebar-content-option-home">{{ language === 'ES'? 'INICIO': 'HOME'}}
    </div>
    <ng-container>
      <div *ngIf="hasMenu('bar') && restaurant.drinksFirst" (click)="goMenu('bar')" class="sidebar-content-option"
        [ngStyle]="{backgroundColor: getColors('bar').background, color: getColors('bar').color}">
        {{ getLabelBarMenu() }}</div>
      <div *ngIf="hasMenu('cocina')" (click)="goMenu('cocina')" class="sidebar-content-option"
        [ngStyle]="{backgroundColor: getColors('cocina').background, color: getColors('cocina').color}">{{ getLabelFoodMenu() }}</div>
      <div *ngIf="hasMenu('bar') && !restaurant.drinksFirst" (click)="goMenu('bar')" class="sidebar-content-option"
        [ngStyle]="{backgroundColor: getColors('bar').background, color: getColors('bar').color}">
        {{ getLabelBarMenu() }}</div>
      <div *ngIf="hasMenu('brunch')" (click)="goMenu('brunch')" class="sidebar-content-option"
        [ngStyle]="{backgroundColor: getColors('brunch').background, color: getColors('brunch').color}">{{ restaurant.labelBrunch ? menuService.getLabelMenu(restaurant.labelBrunch)
        : 'BREAKFAST'}}</div>
      <div *ngIf="hasMenu('extra') && !restaurant.fourMenu" class="sidebar-content-option" (click)="goMenu('extra')"
        [ngStyle]="{backgroundColor: getColors('extra').background, color: getColors('extra').color}">{{
        language === 'ES'? 'EXTRAS': 'EXTRAS'}}</div>
      <div *ngIf="hasMenu('extra') && restaurant.fourMenu" class="sidebar-content-option" (click)="goMenu('extra')"
        [ngStyle]="{backgroundColor: getColors('extra').background, color: getColors('extra').color}">{{
        menuService.getLabelMenu(restaurant.fourMenu) }}</div>
      <div *ngIf="restaurant.services === SERVICES.reserve" (click)="goReserve()">{{ language === 'ES'? 'RESERVA':
        'BOOKING'}}</div>
    </ng-container>
    <div *ngIf="client.partners" (click)="goPartners()">{{ language === 'ES'? 'ALIDADOS':
      'PARTNERS'}}</div>
  </div>
  <div class="row text-center" *ngIf="client.website">
    <div class="col">
      <a [href]="client.website" target="_blank"><strong class="{{menu.fontHeader}} text-underline" [ngStyle]="{'color': getMenuColorText()}">
          {{ language === 'ES'? 'Nuestra página web': 'Website'}}</strong></a>
    </div>
  </div>
</div>